import { UserMessage } from '../../../../types/UserMessage';
import { Tag } from '../../../cdl/Tag/Tag';
import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { useRole } from '../../../common/hooks/useRole';
import { Box } from '../../../common/ui/Box';

import { UserStatusTag } from './UserStatusTag';

interface UserInformationProps {
    user: UserMessage;
}

export const UserInformation = (props: UserInformationProps) => {
    const role = useRole();
    const isCurrentUser = role.user?.id === props.user.id;

    if (props.user.firstname || props.user.lastname) {
        return (
            <Box display="flex" flexDirection="column" gap={4}>
                <Box display="flex" alignItems="center" gap={8}>
                    <Text as="h1" variant="headline">
                        {[props.user.firstname, props.user.lastname].filter(Boolean).join(' ')}
                    </Text>
                    {isCurrentUser ? (
                        <Tag variant="default" emphasis>
                            {translate('user.you')}
                        </Tag>
                    ) : null}
                    <UserStatusTag status={props.user.status} />
                    {props.user.ssoEnabled ? <Tag variant="default">{translate('user.ssoManaged')}</Tag> : null}
                </Box>

                <Text color="foreground.muted">{props.user.email}</Text>
            </Box>
        );
    }

    return (
        <Box>
            <Box display="flex" alignItems="center" gap={6}>
                <Text as="h1" variant="headline">
                    {props.user.email}
                </Text>
                {isCurrentUser ? (
                    <Tag variant="default" emphasis>
                        {translate('user.you')}
                    </Tag>
                ) : null}
                <UserStatusTag status={props.user.status} />
                {props.user.ssoEnabled ? <Tag variant="default">{translate('user.ssoManaged')}</Tag> : null}
            </Box>

            <Text color="foreground.muted">{translate('user.nameNotProvided')}</Text>
        </Box>
    );
};
